<template>
  <section class="bg-white text-black relative justify-center items-center overflow-hidden font-poppins py-14 md:py-20 xl:py-0 xl:pb-10 antialiased">
    <img src="@/assets/bg2.svg" alt="Background Decoration" class="absolute top-0 right-0 z-0 w-full xl:w-1/3 lg:auto opacity-100">
    <div class="container mx-auto px-2 relative z-10">
      <!-- Header -->
      <div class="text-center mb-1 max-w-full mx-auto">
        <div class="flex justify-center items-center mb-6">
          <div class="h-7 rounded-lg w-1 bg-[#186a85] opacity-80"></div>
          <span class="px-2 py-2 bg-opacity-20 text-[#186a85] font-sm text-md tracking-wider">Why choose us</span>
        </div>
        <h2 class="xl:text-3xl lg:text-2xl md:text-xl text-lg font-normal mb-6 leading-tight justify-center items-center">
          Finding the right fit, every time
        </h2>
        <p class="text-gray-500 xl:text-md md:text-sm text-sm justify-center items-center">
          We are more than a software house - we are your technology partner.
        </p>
      </div>

      <!-- GRID -->
      <div class="relative mt-12 px-4 sm:px-6 md:px-12 lg:px-20">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-5 gap-6 max-w-7xl mx-auto">
          <div v-for="(item, index) in services" :key="index" class="relative group overflow-hidden rounded-xl shadow-lg transition-all duration-300 ease-in-out">
            <div class="w-full h-64 bg-gray-100 relative flex flex-col justify-center items-start text-start p-4">
              <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-all duration-300"></div>
              <img 
                :src="hoverImages[index % hoverImages.length]" 
                alt="Hover Image" 
                class="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <img :src="item.icon" alt="icon" class="w-12 h-12 transition group-hover:brightness-0 group-hover:invert">
              <h1 class="mt-4 text-lg font-normal text-gray-800 group-hover:text-white z-10 transition">
                {{ item.title }}
              </h1>
              <p class="mt-2 text-sm text-gray-600 group-hover:text-white z-10 transition">
                {{ item.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      services: [
        { title: "Custom Software Development", description: "Tailored software for your business need.", icon: new URL('@/assets/icon1.svg', import.meta.url).href },
        { title: "IT Consulting & Systems Integration", description: "End-to-end strategy & implementation.", icon: new URL('@/assets/icon2.svg', import.meta.url).href },
        { title: "Cloud-Based Solutions", description: "Secure and scalable cloud service.", icon: new URL('@/assets/icon3.svg', import.meta.url).href },
        { title: "Mobile and Web App Development", description: "Build user-friendly applications.", icon: new URL('@/assets/icon4.svg', import.meta.url).href },
        { title: "Business Automation", description: "AI, machine learning, and digital transformation.", icon: new URL('@/assets/icon5.svg', import.meta.url).href }
      ],
      hoverImages: [
        new URL("@/assets/img-hover1.png", import.meta.url).href,
        new URL("@/assets/img-hover2.png", import.meta.url).href,
        new URL("@/assets/img-hover3.png", import.meta.url).href,
        new URL("@/assets/img-hover4.png", import.meta.url).href,
        new URL("@/assets/img-hover5.png", import.meta.url).href
      ]
    };
  }
};
</script>

<style>
@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-100% / 2)); }
}

.animate-scroll {
  animation: scroll 80s linear infinite;
}

.animate-scroll:hover {
  animation-play-state: paused;
}
</style>
